import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckDateOptions } from '@api/consistencyCheck';

import { extractQueryParams } from '@utils/common';
import { parseStringDate } from '@utils/date';

import { TCMDatesMavenirDatesDTO } from '@interfaces/cmModule/dto/cmModuleDTO';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_DATES } from '@constants/queryKeys';

interface IUseConsistencyCheckDatesReturnType {
	datesOptions: Date[];
	isLoadingDatesOptions: boolean;
}

type TUseConsistencyCheckDates = Partial<TCMDatesMavenirDatesDTO>

const useQueryConsistencyCheckDatesOptions = (
	params: TUseConsistencyCheckDates,
): IUseConsistencyCheckDatesReturnType => {
	const {
		vendor,
		type,
		nodes,
		version,
	} = params;

	const {
		data: datesOptions,
		isLoading: isLoadingDateOptions,
		isFetching: isFetchingDateOptions,
	} = useQuery<string[], Date[]>({
		queryKey: [
			CONSISTENCY_DATES,
			{
				vendor,
				nodes,
				version,
				type,
			},
		],
		queryFn: extractQueryParams(getConsistencyCheckDateOptions),
		select: (data) => data?.map((date) => parseStringDate(date)),
		enabled: [
			vendor,
			nodes,
			version,
			type,
		],
		...refetchOptions,
	});

	return {
		datesOptions: datesOptions || [],
		isLoadingDatesOptions: (isLoadingDateOptions && !!datesOptions)
			|| isFetchingDateOptions,
	};
};

export default useQueryConsistencyCheckDatesOptions;
